module.exports = [{"key":"Under utfylling","text":"Under utfylling"},{"key":"Til behandling","text":"Til behandling"},{"key":"Under behandling","text":"Under behandling"},{"key":"Ferdig behandlet","text":"Ferdig behandlet"}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/status.json
// module id = 699
// module chunks = 0